module.exports = __webpack_public_path__ + "img/cloak.4e0359ab.png";